import React, { useMemo } from 'react';
import Div from '../Div';
import classNames from 'classnames';
import Span from '../Span';
import Button from '../Button';
import RadioCheck from '@/components/Icons/RadioCheck';
import RadioUncheck from '@/components/Icons/RadioUncheck';
import { getProductURL } from '@/utils/urls';
import is from '@/utils/is';
import { EcomGTMEventNames } from '@/types/ecomGTM';
import useEcomGTM from '@/hooks/useEcomGTM';

type VariantCardPropTypes = {
  name: string;
  description?: string;
  price?: string;
  isSelected: boolean;
  materialId: any[];
  isSCAClient?: boolean;
};

export default function VariantCard(props: VariantCardPropTypes) {
  const { name, description, price, isSelected, materialId, isSCAClient } = props;
  const id: string = useMemo(() => {
    const _id = is.array(materialId) ? materialId[0] : materialId;
    return _id;
  }, [materialId]);

  const { fireEcomGTMEvent } = useEcomGTM();

  const pathname = getProductURL(id, '', isSCAClient);
  return (
    <Button
      theme="none"
      className={classNames(
        'flex justify-start rounded-cs p-s5 border border-cti-on-secondary bg-cs-primary cursor-pointer !items-start',
        {
          '!border-blue-400 bg-radio-card-gradient': isSelected,
          //   'mb-s5': data.length !== index + 1,
        },
      )}
      scroll={false}
      onClick={() => {
        fireEcomGTMEvent(EcomGTMEventNames.PDP.VARIANT_CHANGED, {
          is_variant_changed: true,
        });
      }}
      href={isSelected ? '#' : pathname}
      dataTestId={`variant-card-${name}`}
    >
      <Div>{isSelected ? <RadioCheck /> : <RadioUncheck />}</Div>
      <Div className="text-cti-primary font-primary pl-s3 w-full">
        <Div className="flex justify-between">
          <Span className="text-h-4 md:text-hd-4 text-left	">{name}</Span>
          <Span className="text-body-lg md:text-body-xl">{price}</Span>
        </Div>
        {description ? (
          <Div
            className="text-left mt-1.5 text-body-base md:text-body-lg"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : null}
      </Div>
    </Button>
  );
}
